import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40adf2fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-page fill" }
const _hoisted_2 = { class: "login-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-logo" }, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SigninComponent = _resolveComponent("SigninComponent")!
  const _component_NewPasswordComponent = _resolveComponent("NewPasswordComponent")!
  const _component_SignupComponent = _resolveComponent("SignupComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.showLogin && !_ctx.passwordChange)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_SigninComponent, {
              onSignup: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gotoSignup())),
              onNewPassword: _ctx.gotoNewPassword
            }, null, 8, ["onNewPassword"])
          ]))
        : (_ctx.passwordChange)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_NewPasswordComponent, { challenge: _ctx.challengeData }, null, 8, ["challenge"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_SignupComponent, {
                onSaved: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refresh())),
                onSignin: _cache[2] || (_cache[2] = ($event: any) => (_ctx.gotoSignin()))
              })
            ]))
    ])
  ]))
}